import { EJLog } from '../../../../constants/cimsPage/instances/ej'
import { CreateViewEditSoftRemoveRestore, Revert } from '../../common'

const page = EJLog
const object = 'Engineering Judgement'
const plural = 'engineering judgements'

const log = CreateViewEditSoftRemoveRestore({
  page,
  object,
  plural,
  create: '38254df7-d0b2-4fce-951d-09192c096520',
  view: '2c78c858-8c31-42fb-8d73-6339da5c04c4',
  edit: 'b2ba55d5-9670-4040-9a03-2fd78e5424ed',
  removeRestore: '6c88b859-cce4-4ab7-9687-9a2493780e31',
})

export const CreateEngineeringJudgement = log.Create
export const ViewEngineeringJudgement = log.View
export const EditEngineeringJudgement = log.Edit
export const RemoveRestoreEngineeringJudgement = log.RemoveRestore

export const RevertEngineeringJudgement = Revert({
  id: 'f00b5272-ead8-4800-931b-2dddbd9e0457',
  page,
  object,
  plural,
})

export type EJLogPermission =
  | typeof CreateEngineeringJudgement
  | typeof ViewEngineeringJudgement
  | typeof EditEngineeringJudgement
  | typeof RemoveRestoreEngineeringJudgement
  | typeof RevertEngineeringJudgement
